export const SESSION_INACTIVE = 'session_inactive';
export const SESSION_ALREADY_AVAILABLE = 'session_already_available';
export const SESSION_REFRESH_REQUIRED = 'session_refresh_required';
export const SELF_SERVICE_FLOW_RETURN_TO_FORBIDDEN = 'self_service_flow_return_to_forbidden';
export const SELF_SERVICE_FLOW_EXPIRED = 'self_service_flow_expired';
export const SECURITY_CSRF_VIOLATION = 'security_csrf_violation';
export const SECURITY_IDENTITY_MISMATCH = 'security_identity_mismatch';
export const BROWSER_LOCATION_CHANGE_REQUIRED = 'browser_location_change_required';

export const OryErrors = {
    MISSING_FLOW: 'FLow id is missing, should restart the process.',
    MISSING_RECOVERY_CONTEXT: 'Missing account recover context.',
    RECOVER_CONTEXT_EXPIRED: 'Account recover context time expired, should restart the process.'
};
